module.exports = __webpack_public_path__ + "media/משאית.4a172867.mp3";